import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useMarkManualErpSync(
  onSuccess: () => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const markManualErpSyncMutation = useMutation({
    ...trpc.invoices.markManualErpSync.mutationOptions(),
    onSuccess,
    onError,
  });

  const markManualErpSync = (
    merchantid: string,
    invoiceId: string,
    callbacks?: { onSettled?: () => void }
  ) => {
    markManualErpSyncMutation.mutate(
      { rentalsMerchantId: merchantid, id: invoiceId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: trpc.invoices.list.queryKey() });
          setTimeout(() => callbacks?.onSettled?.(), 10000);
        },
        onError: () => {
          callbacks?.onSettled?.();
        },
      }
    );
  };

  return { markManualErpSync };
}
